<template>
<div>
    <h5>*Для отбражения деталей нажми на изображение</h5>

    <table class="table  table-hover table-responsive table-bordered mt-3">
        <thead>
            <tr>
                <th class="center">Детали*</th>
                <th class="center">Модель</th>
                <th class="center" style="width:100%;">Краткое описание</th>
                <th class="center">Стоимость</th>
                <th class="center">Наличие</th>
                <th class="center">Положить в корзину</th>

            </tr>
        </thead>
        <tbody>
            <tr v-for="(i, index) in items" :key="index">
                <td class="center">
                    <tab-modal :item="i" ref="btn"></tab-modal>
                </td>
                <td style="text-align: justify;">
                    {{i.article}}
                </td>
                <td>{{i.short}}</td>

                <td class="center">
                    <strong v-if="+i.price != 0"> {{getPrice(i.price)}}<i class="fa fa-rub" area-hidden="true"></i>
                    </strong>
                    <a href="tel:+73424292513" v-else>
                        <i class="fa fa-phone" area-hidden="true"></i>
                        Уточнить у менеджера
                    </a>

                </td>
                <td class="center">{{ i.nal == 'true' ? 'На удаленном складе' : 'ПОД ЗАКАЗ'}}</td>
                <td class="tocart">
                    <b-btn variant="info" v-if="inCart(i.id) === -1 && i.price > 0" @click="addCart(i)">
                        <i class="fa fa-cart-plus" aria-hidden="true"></i>
                    </b-btn>

                    <b-btn variant="danger" v-else>
                        <i class="fa fa-ban" aria-hidden="true"></i>
                    </b-btn>
                </td>

            </tr>
        </tbody>
    </table>

</div>
</template>

<script>
import TabModal from "../components/TabModal1.vue"

export default {
    props: ['items'],

    components: {
        TabModal
    },
    methods: {
        addCart(item) {
            this.$store.commit('cart/add', item)
        },
        inCart(id) {
            let arr = this.$store.getters['cart/inCart']
            return arr.indexOf(id)
        },
        getPrice(price) {
            let reg = /(\d)(?=(\d\d\d)+([^\d]|$))/g
            return price.replace(reg, '$1 ')
        }

    }

}
</script>

<style scoped>
tr {
    cursor: pointer;
}

.tocart,
.center {
    text-align: center;
    vertical-align: inherit;
}



button:disabled {
    cursor: not-allowed;
}
</style>
